module.exports = "<div class=\"aofl-panel-wrapper\"\n  ng-class=\"{'aofl-panel-active': $ctrl.active}\">\n  <ng-transclude></ng-transclude>\n</div>"